import React, { useEffect } from "react";
import QuestionnaireAccess from "../components/QuestionnaireAccess";
import { GetQuestionnaire, Questionnaire } from "../utils/ServiceManagerAPI";
import { useNavigate, useParams } from "react-router-dom";
import "../main.css";

const QuestionnaireAccessControl = () => {
    const { questionnaireId } = useParams();
    const [questionnaire, setQuestionnaire] = React.useState(null as Questionnaire | null);

    const navigate = useNavigate();

    useEffect(() => {
        if (questionnaireId) {
            getQuestionnaire();
        }
    }, [questionnaireId]);

    const getQuestionnaire = () => {
        GetQuestionnaire(questionnaireId).then((res) => {
            setQuestionnaire(res.questionnaire);
        });
    };

    return (
        <>
            {questionnaire != null && (
                <QuestionnaireAccess
                    questionnaire={questionnaire}
                    reviews={[]}
                    onChange={() => {
                        getQuestionnaire();
                    }}
                ></QuestionnaireAccess>
            )}

            <div className="flex flex-row justify-end gap-2 mt-4">
                <button 
                    className="px-4 py-2 rounded bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-gray-100 hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors"
                    onClick={() => {
                        navigate(-1);
                    }}
                >
                    Close
                </button>
            </div>
        </>
    );
};

export default QuestionnaireAccessControl;
